import { RouteConfig } from 'vue-router';

import { multiGuard } from '../Middleware/MultiGuard';
import { permissionDoubtsWithFree, permissionDoubts, permissionDoubtsCredits } from '../Middleware/permission/Doubts';
import { permissionFeature } from '../Middleware/permission/Feature';

export const NAME_ROUTES_DOUBTS = {
  LIST: 'Doubts',
  SHOW: 'ShowDoubts',
  NEW: 'NewDoubt'
};

export const Doubts: Array<RouteConfig> = [
  {
    path: '/duvidas',
    component: () => import('@/layouts/Default/index.vue'),
    beforeEnter: permissionDoubtsWithFree,
    children: [
      {
        path: '',
        name: NAME_ROUTES_DOUBTS.LIST,
        component: () => import(/* webpackChunkName: "doubts" */ '@/pages/Doubts/Doubts.vue'),
        meta: { title: 'Dúvidas' }
      },
      {
        path: 'enviar',
        name: NAME_ROUTES_DOUBTS.NEW,
        component: () => import(
          /* webpackChunkName: "doubts-send" */ '@/pages/Doubts/pages/NewDoubt/NewDoubt.vue'
        ),
        meta: { title: 'Enviar Dúvida' },
        beforeEnter: multiGuard([permissionFeature, permissionDoubtsCredits])
      }
    ]
  },
  {
    path: '/duvida/:id',
    component: () => import('@/layouts/Default/index.vue'),
    beforeEnter: permissionDoubtsWithFree,
    children: [
      {
        path: '',
        name: NAME_ROUTES_DOUBTS.SHOW,
        component: () => import(
          /* webpackChunkName: "doubts-show" */ '@/pages/Doubts/pages/ShowDoubts/ShowDoubts.vue'
        ),
        meta: { title: 'Visualização da Dúvida' },
        beforeEnter: multiGuard([permissionFeature, permissionDoubts])
      }
    ]
  }
];
